import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import Screen from '../../../../shared/utils/screen';

interface Props {
  disableWidth?: boolean;
}

const SquareImage = styled.img<Props>`
  border-radius: ${16 * Screen.widthRatio}px;
  padding-left: ${2 * Screen.widthRatio}px;
  width: ${80 * Screen.widthRatio}px;
  height: ${80 * Screen.widthRatio}px;
`;

export default withImage(SquareImage, false);
